import type { FetchPermissionsFulfilledAction } from "entities/permissions/actionTypes";
import { PermissionsType } from "entities/permissions/actionTypes";

export const fetchPermissionsSuccess = (
  payload: FetchPermissionsFulfilledAction["payload"],
): FetchPermissionsFulfilledAction => ({
  type: PermissionsType.FETCH_FULFILLED,
  payload,
});
